import { useEffect, useRef, type RefObject } from 'react';
import { requireLegacy, type TurnstileWidgetHandle } from '../../legacy/legacyGlobals';

/**
 * Renders the legacy Turnstile widget (explicit-render mode, with its own
 * slow-network retries) into a container once per mount. The handle's
 * getToken() stays null until the check completes — callers treat that as
 * "not ready yet", never as an error to surface.
 */
export function useTurnstileWidget(containerRef: RefObject<HTMLElement | null>): TurnstileWidgetHandle {
  const handleRef = useRef<TurnstileWidgetHandle | null>(null);

  useEffect(() => {
    handleRef.current = requireLegacy('renderTurnstile')(containerRef.current!);
  }, [containerRef]);

  return {
    getToken: () => handleRef.current?.getToken() ?? null,
    reset: () => handleRef.current?.reset(),
  };
}
